// Waits for someone to finish signing in through a popup, by asking the server.
//
// popup.closed cannot answer that. A sign-in page sent with Cross-Origin-Opener-Policy cuts
// this window off from its popup, and popup.closed then reads true while the person is still
// signing in. Pipedrive's, monday.com's and Google's pages all do this (seen in a real
// browser, Nov 2026). So a popup that reads as closed only slows the asking, in case it
// really is closed. `check` resolves true once the sign-in has landed, the wait gives up
// after WATCH_LIMIT_MS, and `onDone(landed)` runs once either way.
export const WATCH_LIMIT_MS = 10 * 60 * 1000;
const UNSEEN_POLL_MS = 2000;
const LATE_POLL_MS = 5000;
const LATE_AFTER_MS = 3 * 60 * 1000;

export function watchSignInPopup(
  popup,
  { check, onDone, intervalMs = 850, keepPopupOpen = false },
) {
  // The browser blocked the popup, so nothing can land.
  if (!popup) {
    onDone?.(false);
    return;
  }
  const startedAt = Date.now();
  let finished = false;
  let timer = null;

  const finish = async (landed) => {
    finished = true;
    clearTimeout(timer);
    window.removeEventListener("focus", ask);
    if (landed && !keepPopupOpen && !popup.closed) popup.close();
    await onDone?.(landed);
  };

  async function ask() {
    if (finished) return;
    clearTimeout(timer);
    let landed = false;
    try {
      landed = !!(await check());
    } catch {}
    if (finished) return;
    const elapsed = Date.now() - startedAt;
    if (landed || elapsed >= WATCH_LIMIT_MS) {
      await finish(landed);
      return;
    }
    const unseenDelay = elapsed < LATE_AFTER_MS ? UNSEEN_POLL_MS : LATE_POLL_MS;
    timer = setTimeout(ask, popup.closed ? unseenDelay : intervalMs);
  }

  // The popup closing hands focus back here, so the card can update at once.
  window.addEventListener("focus", ask);
  timer = setTimeout(ask, intervalMs);
}
